import StudentModel from "../../../../api/models/StudentModel";

export type ProgressOption = {
  name: string;
  value: number;
  color: string;
};

export const getSessionsProgressOptions = (student: StudentModel) => {
  return [
    {
      name: "done",
      value: student?.finished_sessions_count || 0,
      color: "#10B981",
    },
    {
      name: "total",
      value: student?.total_sessions_count || 60,
      color: "#D1D5DB",
    },
  ] as [ProgressOption, ProgressOption];
};
export const getQuraanProgressOptions = (student: StudentModel) => {
  return [
    {
      name: "done",
      value:
        student?.lastQuranPageReached ||
        (student as any)?.last_quran_page_reached,
      color: "#0063C7",
    },
    {
      name: "total",
      value: student?.totalQuraanPages ?? 604,
      color: "#D1D5DB",
    },
  ] as [ProgressOption, ProgressOption];
};

export function getStudentPieChartOptions(
  Labels: string[],
  data: number[],
  colors: string[]
) {
  return {
    options: {
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false,
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      colors: colors,
      labels: Labels,
    },
    series: data,
  };
}
